import http from '@core/fetch'
export default {
  // 获取商家信息，判断是否签署商家是否签署上上签
  checkSigned: body =>
    http('/p/wedding/Admin/APIContract/checkSigned', {
      body
    }),
  // 生成上上签地址页面
  buildBuild: body =>
    http.post('/p/wedding/Admin/APIContract/build', {
      body
    })
}
